import React from "react";
import "./Terms_Conditions.css";

import Terms_Conditions_content from "./Terms_Conditions_content/Terms_Conditions_content";

function Terms_Conditions() {
  return (
    <>
      <section className="Terms_Conditions">
        <Terms_Conditions_content />
      </section>
    </>
  );
}

export default Terms_Conditions;
